export const conceptNoteTextFields = [
  { name: "activity_venue", label: "Activity Venue", required: true },
  {
    name: "background_to_activity",
    label: "Background to the activity",
    required: true,
    bulleted: true,
  },
  {
    name: "activity_specific_objectives",
    label: "Activity Specific Objectives",
    bulleted: true,
  },
  { name: "methodology", label: "Methodology", required: true, bulleted: true },
  {
    name: "activity_expected_output",
    label: "Activity Expected Outputs",
    bulleted: true,
  },
  {
    name: "activity_expected_outcomes",
    label: "Activity Expected Outcomes",
    bulleted: true,
  },
  { name: "implementer", label: "Implementing Partners", bulleted: true },
  { name: "target_participants", label: "Target Participants", bulleted: true },
  {
    name: "community_led_strategy",
    label: "Community Led Approach",
    bulleted: true,
  },
];

export const invitedParticipantColumns = [
  { name: "name", label: "Name" },
  { name: "organization", label: "Organization" },
  { name: "role", label: "Role" },
  { name: "contact", label: "Contact" },
  { name: "location", label: "Location" },
];

export const INVITED_PARTICIPANTS_LABEL =
  "List of invited and expected participants (Name/Organization/Role/Contact/Location)";

export const conceptNoteTableStyle = { tableLayout: "fixed", width: "100%" };
export const subTitleColumnStyle = { width: "28%" };
export const conceptNoteCellStyle = {
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};

export const wrapOptionRender = (option) => (
  <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
    {option.label}
  </div>
);
